function overwriteConfig(config, overwrite)
{
    Object.assign(config, overwrite)
}

export default { overwriteConfig }


// WEBPACK FOOTER //
// ./src/utils/configUtils.js